import { render, staticRenderFns } from "./JServiceWorkerUpdate.vue?vue&type=template&id=2bc57d78"
import script from "./JServiceWorkerUpdate.vue?vue&type=script&lang=ts"
export * from "./JServiceWorkerUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports